import { ICreateDocumentDtoDocumentTypeEnum } from '@/types';
import { baseStoreCreator } from '@/utils/store';

import { LMNClaim } from '../LettersOfMedicalNecessity.types';

export interface LettersOfMedicalNecessityPopupState {
  name?: string;
  description?: string;
  documentType?: ICreateDocumentDtoDocumentTypeEnum;
  employeeId?: string;
  claimIds?: string[];
  validDates?: Date[];
  createdLMNId?: string;
  associatedClaims?: LMNClaim[];
  onError?: () => Promise<void>;
}

export const DEFAULT_VALUES: LettersOfMedicalNecessityPopupState = {
  name: undefined,
  description: undefined,
  documentType: undefined,
  employeeId: undefined,
  claimIds: [],
  validDates: [],
  createdLMNId: undefined,
  associatedClaims: [],
  onError: undefined,
};

export const useLettersOfMedicalNecessityPopupStore =
  baseStoreCreator<LettersOfMedicalNecessityPopupState>(DEFAULT_VALUES);

export default useLettersOfMedicalNecessityPopupStore;
